"use client";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import { useOptimizedSectionTracking } from "@/utils/performance/scrollOptimizations";

const BridgeTable: React.FC = () => {
  const [activeSection, setActiveSection] = useState<string>("section1");
  const bannerImageList = [
    "/images/business/business-bg.png",
    "/images/accounting/mask2.png",
  ];
  let currentIndex = 0;

  const [activeTab, setActiveTab] = useState("tab1");

  useEffect(() => {
    const marqueeContent = document.querySelector(
      ".marquee-content",
    ) as HTMLElement;

    // Duplicate the marquee content to ensure a seamless loop
    if (marqueeContent) {
      const items = Array.from(marqueeContent.children);
      items.forEach((item) => marqueeContent.appendChild(item.cloneNode(true)));
    }

    function changeImage() {
      const imgElement = document.getElementById(
        "dynamic_banner_img",
      ) as HTMLImageElement;
      const textMaskElement = document.getElementById("text-mask");
      if (imgElement && textMaskElement) {
        currentIndex = (currentIndex + 1) % bannerImageList.length;
        imgElement.style.opacity = "0";
        setTimeout(() => {
          imgElement.src = bannerImageList[currentIndex];
          textMaskElement.style.backgroundImage =
            "url(" + bannerImageList[currentIndex] + ")";
          imgElement.style.opacity = "1";
        }, 500);
        setTimeout(changeImage, 5000);
      }
    }
    changeImage();
  }, []);

  // Use optimized section tracking instead of manual scroll handler
  const sections = [
    "section1",
    "section2",
    "section3",
    "section4",
    "section5",
    "section7",
  ];

  useOptimizedSectionTracking(sections, (active) => setActiveSection(active), {
    offset: 200,
    throttleMs: 100,
  });

  return (
    <div className="w-full px-8 py-16 text-black shadow-xl md:bg-[url(/home/footer_bg.png)] max-md:px-5 relative">
      <h2 className="font-semibold md:text-[24px] text-[20px] text-black text-center mb-16">
        Miles Approved Bridge Programs for
        <br />
        <span className="border-[#ca7216] border-b-[4px] md:text-[32px] text-[20px]">
          Pre-education Eligibility for the CPA Exam
        </span>
      </h2>
      <div className="business-executive main_container text-[#000] z-10 md:block hidden">
        <div className="flex justify-between relative z-10 mx-auto">
          <nav className="md:w-[32%] h-[500px] sticky top-[180px] left-10">
            <ul className="pl-[10%] font-medium">
              {[
                {
                  section: "section1",
                  image: "/images/business/soba/GraduationCap.svg",
                  title: "M.com - ",
                  subtitle: "Professional Accounting & Finance",
                  subtitle1: "60 credits",
                  subtitle2: "Timeline: 2 year program",
                  subtitle3: "Fees: 45,500/-",
                  subtitle4: "No cost EMI available",
                  subtitle5: "100% CPA Integrated curriculum",
                  sec: "tab1",
                },
                // {
                //   section: "section2",
                //   image: "/images/business/soba/Building.svg",
                //   title: "MBA - ",
                //   subtitle: "Strategic Finance",
                //   subtitle1: "60 credits",
                //   subtitle2: "Timeline: 2 year program",
                //   subtitle3: "Fees: 1,30,500/-",
                //   subtitle4: "No cost EMI available",
                //   subtitle5: "60% CPA integrated curriculum",
                //   sec: "tab2",
                // },
                {
                  section: "section3",
                  image: "/images/business/soba/Globe.svg",
                  title: "PGD - ",
                  subtitle: "Accounting and Finance",
                  subtitle1: "30 credits",
                  subtitle2: "Timeline: 1 year program",
                  subtitle3: "Fees: 30,500/-",
                  subtitle4: "No cost EMI available",
                  subtitle5: "100% CPA Integrated curriculum",
                  sec: "tab3",
                },
              ].map(
                ({
                  section,
                  title,
                  subtitle,
                  subtitle1,
                  subtitle2,
                  subtitle3,
                  subtitle4,
                  subtitle5,
                  image,
                  sec,
                }) => (
                  <li
                    key={section}
                    className={`cursor-pointer flex items-start gap-4 mb-4 w-[320px] h-auto p-4 rounded-[14px] border-2 border-[#3174d6] bg-[#FFF] shadow-[99px_131px_46px_rgba(4,84,175,0.00),64px_84px_42px_rgba(4,84,175,0.01),36px_47px_35px_rgba(4,84,175,0.05),16px_21px_26px_rgba(4,84,175,0.09),4px_5px_14px_rgba(4,84,175,0.10)] ${
                      activeSection === section && activeTab === sec
                        ? "text-black font-bold"
                        : ""
                    }`}
                    onClick={() => {
                      setActiveTab(sec);
                      setActiveSection(section);
                    }}
                  >
                    <Image
                      src={image} // Each row has a specific image on the left
                      alt={`Image for ${title} ${subtitle}`}
                      className="w-[38.4px] h-[38.4px] flex-shrink-0 mr-4" // Adjust dimensions and margin as needed
                      width={38.4}
                      height={38.4}
                    />
                    <div>
                      <span className="text-[20px] leading-[1.3]">
                        {title}
                        <span className="font-medium">{subtitle}</span>
                      </span>
                      {activeSection === section && activeTab === sec && (
                        <ul className="text-[14.6px] font-medium leading-[1.3] text-black mt-1 list-disc pl-5 ">
                          {subtitle1 && (
                            <li className="ml-[-0.5em]">{subtitle1}</li>
                          )}
                          {subtitle2 && (
                            <li className="ml-[-0.5em]">{subtitle2}</li>
                          )}
                          {subtitle3 && (
                            <li className="ml-[-0.5em]">{subtitle3}</li>
                          )}
                          {subtitle4 && (
                            <li className="ml-[-0.5em]">{subtitle4}</li>
                          )}
                          {subtitle5 && (
                            <li className="ml-[-0.5em]">{subtitle5}</li>
                          )}
                        </ul>
                      )}
                    </div>
                  </li>
                ),
              )}
            </ul>
          </nav>

          <div className="md:w-[64%] md:pl-2 border-[#6666] flex flex-col gap-8 mr-24">
            {activeTab === "tab1" && activeSection === "section1" ? (
              <section
                key="section1"
                id="section1"
                onClick={() => setActiveTab("tab1")}
              >
                <div className="border-[#1D5287] border-[1px] md:w-[106%] w-full mx-auto rounded-[8px] overflow-hidden">
                  <div className="overflow-hidden">
                    <table className="w-full">
                      <thead>
                        <tr className="border-b border-[#3174d6] bg-[linear-gradient(90deg,#0c1f33_0%,#09284a_55%,#0448aa_99.5%)] w-full text-white font-semibold ">
                          <th className="md:w-[3%] border-[1px] border-[#1D5287] py-[28px]"></th>

                          <th className="md:w-[20%] border-[1px] border-[#1D5287] md:text-[24px]">
                            <span>Courses</span>
                          </th>
                          <th className="md:w-[18%] border-[1px] border-[#1D5287] md:text-[24px]">
                            <span>CPA Integration</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-[#FFF]">
                        <tr className="">
                          <td className="border-[1px] font-semibold border-[#1D5287]">
                            <span className="py-3 md:px-8 px-2 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              Sem 1
                            </span>
                          </td>

                          <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                            <ul className="py-3 md:px-8 px-5 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              <li>Financial Accounting & Reporting</li>
                              <li>Technical Accounting & Reporting - I</li>
                              <li>Management Accounting - I</li>
                              <li>Business Finance - I</li>
                              <li>Business Economics - I</li>
                            </ul>
                          </td>

                          <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                            <ul className="py-3 md:px-8 px-2 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              <li>FAR 1</li>
                              <li>FAR 3</li>
                              <li>FAR 2 & 6.2</li>
                              <li>FAR 4</li>
                              <li>FAR 4.3</li>
                            </ul>
                          </td>
                        </tr>
                        <tr className="">
                          <td className="border-[1px] font-semibold border-[#1D5287]">
                            <span className="py-3 md:px-8 px-2 md:text-[16px] text-[16px] text-black font-semibold list-disc list-inside block">
                              Sem 2
                            </span>
                          </td>

                          <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                            <ul className="py-3 md:px-8 px-5 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              <li>Business Finance - II</li>
                              <li>Not-for-Profit & Governmental Accounting</li>
                              <li>Auditing & Attestation - I</li>
                              <li>Business Economics - II</li>
                              <li>Business Law - I</li>
                              <li>Federal Income Taxation - I</li>
                            </ul>
                          </td>
                          <td className="border-[1px] font-semibold border-[#1D5287]">
                            <ul className="py-3 md:px-8 px-5 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              <li>FAR 5 & 6.1</li>
                              <li>FAR 6.5 & 7</li>
                              <li>AUD 1, 2, 3</li>
                              <li>BAR 4.4, BAR 4.5</li>
                              <li>REG 7.1, 7.2</li>
                              <li>REG 1</li>
                            </ul>
                          </td>
                        </tr>
                        <tr className="">
                          <td className="border-[1px] font-semibold border-[#1D5287]">
                            <span className="py-3 md:px-8 px-2 md:text-[16px] text-[16px] text-black font-semibold list-disc list-inside block">
                              Sem 3
                            </span>
                          </td>

                          <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                            <ul className="py-3 md:px-8 px-5 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              <li>Management Accounting - II</li>
                              <li>Technical Accounting & Reporting - II</li>
                              <li>Auditing & Attestation - II</li>
                              <li>Federal Income Taxation - II</li>
                              <li>Financial Decision Making</li>
                              <li>Business Communication & Ethics</li>
                            </ul>
                          </td>
                          <td className="border-[1px] font-semibold border-[#1D5287]">
                            <ul className="py-3 md:px-8 px-5 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              <li>BAR-2</li>
                              <li>BAR-5</li>
                              <li>AUD 4, 5</li>
                              <li>REG 2 & 3</li>
                              <li>BAR-1, 4.1, 4.2</li>
                              <li>(Elective)</li>
                            </ul>
                          </td>
                        </tr>
                        <tr className="">
                          <td className="border-[1px] font-semibold border-[#1D5287]">
                            <span className="py-3 md:px-8 px-2 md:text-[16px] text-[16px] text-black font-semibold list-disc list-inside block">
                              Sem 4
                            </span>
                          </td>

                          <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                            <ul className="py-3 md:px-8 px-5 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              <li>Business Law - II</li>
                              <li>Technical Accounting & Reporting - III</li>
                              <li>Auditing & Attestation - III</li>
                              <li>Federal Income Taxation - III</li>
                              <li>Business Law - I</li>
                              <li>Master Thesis / Project</li>
                            </ul>
                          </td>
                          <td className="border-[1px] font-semibold border-[#1D5287]">
                            <ul className="py-3 md:px-8 px-5 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              <li>REG 7.3 - 7.7</li>
                              <li>BAR 6 & 3</li>
                              <li>AUD 6, 7</li>
                              <li>REG 4 & 5</li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </section>
            ) : activeTab === "tab2" ? (
              <section key="section2" id="section2">
                {" "}
                <div className="border-[#1D5287] border-[1px] md:w-[106%] w-full mx-auto rounded-[8px] overflow-hidden">
                  <div className="overflow-hidden">
                    <table className="w-full">
                      <thead>
                        <tr className="border-b border-[#3174d6] bg-[linear-gradient(90deg,#0c1f33_0%,#09284a_55%,#0448aa_99.5%)] w-full text-white font-semibold ">
                          <th className="md:w-[3%] border-[1px] border-[#1D5287] py-[28px]"></th>

                          <th className="md:w-[20%] border-[1px] border-[#1D5287] md:text-[24px]">
                            <span>Courses</span>
                          </th>
                          <th className="md:w-[18%] border-[1px] border-[#1D5287] md:text-[24px]">
                            <span>CPA Integration</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-[#FFF]">
                        <tr className="">
                          <td className="border-[1px] font-semibold border-[#1D5287]">
                            <span className="py-3 md:px-8 px-2 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              Sem 1
                            </span>
                          </td>

                          <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                            <ul className="py-3 md:px-8 px-5 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              <li>Principles of Economics and Markets</li>
                              <li>Managerial Effectiveness and Ethics</li>
                              <li>Accounting and Finance</li>
                              <li>
                                Organizational Behavior and Human Resources
                                Management
                              </li>
                              <li>Quantitative Techniques and Analytics</li>
                            </ul>
                          </td>

                          <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                            <ul className="py-3 md:px-8 px-2 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              {/* <li>FAR 1</li>
                              <li>FAR 3</li>
                              <li>FAR 2 & 6.2</li>
                              <li>FAR 4</li>
                              <li>FAR 4.3</li> */}
                            </ul>
                          </td>
                        </tr>
                        <tr className="">
                          <td className="border-[1px] font-semibold border-[#1D5287]">
                            <span className="py-3 md:px-8 px-2 md:text-[16px] text-[16px] text-black font-semibold list-disc list-inside block">
                              Sem 2
                            </span>
                          </td>

                          <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                            <ul className="py-3 md:px-8 px-5 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              <li>Entrepreneurship</li>
                              <li>Marketing Management and Research</li>
                              <li>Banking, Financial Services and Insurance</li>
                              <li>Corporate Law</li>
                              <li>Business Analytics</li>
                            </ul>
                          </td>
                          <td className="border-[1px] font-semibold border-[#1D5287]">
                            <ul className="py-3 md:px-8 px-5 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              {/* <li>FAR 5 & 6.1</li>
                              <li>FAR 6.5 & 7</li>
                              <li>AUD 1, 2, 3</li>
                              <li>BAR 4.4, BAR 4.5</li>
                              <li>REG 7.1, 7.2</li>
                              <li>REG 1</li> */}
                            </ul>
                          </td>
                        </tr>
                        <tr className="">
                          <td className="border-[1px] font-semibold border-[#1D5287]">
                            <span className="py-3 md:px-8 px-2 md:text-[16px] text-[16px] text-black font-semibold list-disc list-inside block">
                              Sem 3
                            </span>
                          </td>

                          <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                            <ul className="py-3 md:px-8 px-5 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              <li>Business Environment and Strategy</li>
                              <li>Operations Management</li>
                              <li>
                                Advanced Financial Accounting & Reporting - I
                              </li>
                              <li>International Auditing - I</li>
                              <li>International Taxation</li>
                              <li>Open Elective Course</li>
                            </ul>
                          </td>
                          <td className="border-[1px] font-semibold border-[#1D5287]">
                            <ul className="py-3 md:px-8 px-5 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              <li>FAR 1, 2, 3</li>
                              <li>AUD 1, 2, 3</li>
                              <li>REG 1, 2, 3, 4</li>
                            </ul>
                          </td>
                        </tr>
                        <tr className="">
                          <td className="border-[1px] font-semibold border-[#1D5287]">
                            <span className="py-3 md:px-8 px-2 md:text-[16px] text-[16px] text-black font-semibold list-disc list-inside block">
                              Sem 4
                            </span>
                          </td>

                          <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                            <ul className="py-3 md:px-8 px-5 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              <li>Performance Management System</li>
                              <li>
                                Advanced Financial Accounting & Reporting - II
                              </li>
                              <li>International Auditing - II</li>
                              <li>Business Analysis</li>
                              <li>Cross-Functional Elective Course</li>
                            </ul>
                          </td>
                          <td className="border-[1px] font-semibold border-[#1D5287]">
                            <ul className="py-3 md:px-8 px-5 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              <li>FAR 4, 5, 6, 7</li>
                              <li>AUD 4, 5, 6, 7</li>
                              <li>BAR 1, 2, 3</li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </section>
            ) : (
              <section key="section3" id="section3">
                {" "}
                <div className="border-[#1D5287] border-[1px] md:w-[106%] w-full mx-auto rounded-[8px] overflow-hidden">
                  <div className="overflow-hidden">
                    <table className="w-full">
                      <thead>
                        <tr className="border-b border-[#3174d6] bg-[linear-gradient(90deg,#0c1f33_0%,#09284a_55%,#0448aa_99.5%)] w-full text-white font-semibold ">
                          <th className="md:w-[3%] border-[1px] border-[#1D5287] py-[28px]"></th>

                          <th className="md:w-[20%] border-[1px] border-[#1D5287] md:text-[24px]">
                            <span>Courses</span>
                          </th>
                          <th className="md:w-[18%] border-[1px] border-[#1D5287] md:text-[24px]">
                            <span>CPA Integration</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-[#FFF]">
                        <tr className="">
                          <td className="border-[1px] font-semibold border-[#1D5287]">
                            <span className="py-3 md:px-8 px-2 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              Sem 1
                            </span>
                          </td>

                          <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                            <ul className="py-3 md:px-8 px-5 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              <li>Financial Accounting & Reporting</li>
                              <li>Technical Accounting & Reporting - I</li>
                              <li>Management Accounting - I</li>
                              <li>Business Finance - I</li>
                              <li>Business Economics - I</li>
                            </ul>
                          </td>

                          <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                            <ul className="py-3 md:px-8 px-2 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              <li>FAR 1</li>
                              <li>FAR 3</li>
                              <li>FAR 2 & 6.2</li>
                              <li>FAR 4</li>
                              <li>BAR 4.3</li>
                            </ul>
                          </td>
                        </tr>
                        <tr className="">
                          <td className="border-[1px] font-semibold border-[#1D5287]">
                            <span className="py-3 md:px-8 px-2 md:text-[16px] text-[16px] text-black font-semibold list-disc list-inside block">
                              Sem 2
                            </span>
                          </td>

                          <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                            <ul className="py-3 md:px-8 px-5 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              <li>Business Finance - II</li>
                              <li>Not-for-Profit & Governmental Accounting</li>
                              <li>Auditing & Attestation - I</li>
                              <li>Business Economics - II</li>
                              <li>Business Law - I</li>
                              <li>Federal Income Taxation - I</li>
                            </ul>
                          </td>
                          <td className="border-[1px] font-semibold border-[#1D5287]">
                            <ul className="py-3 md:px-8 px-5 md:text-[16px] text-[16px] text-black block font-semibold list-disc list-inside">
                              <li>FAR 5 & 6.1</li>
                              <li>FAR 6.5 & 7</li>
                              <li>AUD 1, 2, 3</li>
                              <li>BAR 4.4, BAR 4.5</li>
                              <li>REG 7.1, 7.2</li>
                              <li>REG 1</li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </section>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BridgeTable;
